<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card class="mx-auto my-12" max-width="760">
                    <v-card-title>
                        <v-row>
                            <v-col cols="12" class="text-center mt-3">
                                <span class="title-xx"
                                    >Tracking Case System</span
                                >
                            </v-col>
                            <v-col cols="12" class="mt-5">
                                <v-text-field
                                    style="font-size: 25px"
                                    rounded
                                    dense
                                    outlined
                                    label="Search Case ID / ค้นหาจากเลขเคส"
                                    v-model="case_id"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <!--   <v-row>
                          <v-col cols="12" class="text-center">
                                <vue-recaptcha
                                    sitekey="6Lew3w8hAAAAAOyi5OQGDnIyFC2UEyzS4XMHCF5V"
                                ></vue-recaptcha>
                            </v-col>
                        </v-row> -->

                        <v-row class="mar-t-15" v-if="case_id != ''">
                            <v-col
                                cols="12"
                                class="text-center font-q1"
                                :class="
                                    input == result
                                        ? 'success--text'
                                        : 'primary--text'
                                "
                            >
                                <template v-for="num in countNumber">
                                    {{ num }}
                                </template>
                            </v-col>
                            <v-col
                                cols="12"
                                class="mar-t-20"
                                v-if="input != result"
                            >
                                <v-text-field
                                    v-model.number="input"
                                    type="number"
                                    label="Please enter the number above. / กรุณากรอกตัวเลขข้างบน"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-btn
                                    color="success"
                                    @click="get_data()"
                                    class="mr-1"
                                    rounded
                                    block
                                    :disabled="case_id == '' || input != result"
                                >
                                    Search
                                </v-btn>
                            </v-col>
                        </v-row>
                        <!-- <v-btn
                                    small
                                    fab
                                    v-if="case_id != ''"
                                    @click="reset()"
                                >
                                    <v-icon>mdi-rotate-left</v-icon>
                                </v-btn> -->
                        <v-row v-if="show_data == true" class="mt-2">
                            <v-col cols="12" class="mb-5">
                                <hr />
                            </v-col>
                            <v-col cols="12">
                                <span class="text--01"> Case ID : </span>
                                <span class="text--02 ml-2">
                                    {{ data_main.case_id }}
                                </span>
                            </v-col>
                            <v-col cols="12">
                                <span class="text--01"> Case Title : </span>
                                <span class="text--02 ml-2">
                                    {{ data_main.case_title }}
                                </span>
                            </v-col>
                            <v-col cols="12">
                                <span class="text--01"> Status : </span>
                                <span class="text--02 ml-2">
                                    {{ data_main.sub_status_name }}
                                </span>
                            </v-col>
                            <v-col cols="12">
                                <span class="text--01"> Date Open : </span>
                                <span class="text--02 ml-2">
                                    {{ data_main.created_at }}
                                </span>
                            </v-col>
                            <v-col cols="12">
                                <span class="text--01"> Date Onsite : </span>
                                <span class="text--02 ml-2">
                                    {{ data_main.onsite_at }}
                                </span>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <br />
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"
let url = `${process.env.VUE_APP_ROOT_API}/api/`
//import { VueRecaptcha } from "vue-recaptcha"

export default {
    //  components: { VueRecaptcha },
    methods: {
        onEvent() {
            // when you need a reCAPTCHA challenge
            this.$refs.recaptcha.execute()
            // console.log(this.$refs.recaptcha.execute(), "-reCaptcha")
        },
        async get_data() {
            this.dialog_loading = true
            let search = {
                case_id: this.case_id,
            }
            await axios
                .post(url + "search-case-detail/", search)
                .then((response) => {
                    this.data_main = response.data.data
                    // console.log(this.data_main)
                    if (response.data.status == "ok") {
                        this.show_data = true
                        this.case_id = ""
                    } else {
                        this.$swal(response.data.message, {
                            icon: "warning",
                            button: false,
                            timer: 2000,
                        })
                    }
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        reset() {
            this.case_id = ""
            this.data_main = []
            this.show_data = false
        },
        valid() {
            return this.input == this.result
        },
    },
    computed: {
        result() {
            return this.countNumber.join("")
        },
        countNumber() {
            let num = []
            for (var i = 0; i < this.randCount; i++) {
                num.push(Math.floor(Math.random() * 10))
            }
            return num
        },
        randCount() {
            return Math.floor(
                this.countMin +
                    Math.random() * (this.countMax + 1 - this.countMin)
            )
        },
    },
    data() {
        return {
            show_data: false,
            data_main: [],
            case_id: "",
            dialog_loading: false,
            url: "https://my-json-server.typicode.com/typicode/demo/posts",
            input: "",
            countMin: 4,
            countMax: 8,
            numbers: [
                // 0
                [1, 1, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 1, 1],
                // 1
                [0, 0, 1, 0, 1, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1],
                // 2
                [1, 1, 1, 0, 0, 1, 0, 1, 1, 1, 0, 0, 1, 1, 1],
                // 3
                [1, 1, 1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 1, 1, 1],
                // 4
                [1, 0, 1, 1, 0, 1, 1, 1, 1, 0, 0, 1, 0, 0, 1],
                // 5
                [1, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 1],
                // 6
                [1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1],
                // 7
                [1, 1, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 0, 1, 0],
                // 8
                [1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1],
                // 9
                [1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1],
            ],
        }
    },
}
</script>
<style scoped>
.title-xx {
    font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
        "Lucida Sans", Arial, sans-serif;
    color: #034257 !important;
    text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0) !important;
    text-align: center;
    /* position: absolute; */
    /* left: 50%;
    top: 50%; */
    /* transform: translate(-50%, -50%); */
    letter-spacing: 0.05em;
    font-size: 40px;
    padding: 5px 0;
}
.text--01 {
    font-weight: bold;
    font-size: 18px;
    color: rgb(49, 63, 75);
}
.text--02 {
    font-weight: bold;
    font-size: 18px;
    color: rgb(25, 81, 131);
}
/* .num {
    margin: 0;
    margin-bottom: 15px;
}

.red {
    background-color: tomato;
}

.cell {
    height: 40px;
} */
</style>
